import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteModal',
  props: {
    value: { type: Boolean, default: undefined },
    confirmLabel: { default: undefined }
  },
  emits: ["input", "delete", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void
  (e: 'delete'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, confirmLabel: string };




const internalValue = ref(props.value ?? false)
const isOpen = computed({
  get: () => props.value ?? internalValue.value,
  set: (value) => {
    internalValue.value = value
    emit('input', value)
  },
})

return { __sfc: true,props, emit, internalValue, isOpen }
}

})